import { css } from "@tento-ui/component-styles";
import { ChatThemes } from "../chat-theme";
import type { ChatTheme } from "../chat-theme";

/**
 * The messenger look proper: iMessage's blue sent / gray received, 18px
 * corners, and the grouped-run grammar — within a turn each content block is
 * its own bubble and the corners where adjacent bubbles meet stand down to
 * 4px (the register's --chat-bubble-adjacent-radius seam). Tool calls read
 * as ADMIN MESSAGES: iMessage's system-line grammar, no ground of their own.
 */
export const IMessageLook: ChatTheme = {
  ...ChatThemes.bubbles(),
  name: "imessage",
  $style: css`
    :host {
      background: #fff;
      --thread-top-inset: 12px;
      --thread-bottom-inset: 12px;
      --chat-bubble-ground: #0a84ff;
      --chat-bubble-ink: #fff;
      --chat-bubble-radius: 18px;
      --chat-bubble-adjacent-radius: 4px;
      --chat-bubble-assistant-ground: #e9e9eb;
      --chat-bubble-assistant-ink: #000;
      --chat-bubble-assistant-radius: 18px;
      --chat-bubble-assistant-padding: 10px 14px;
      --chat-bubble-assistant-max-width: 80%;
      /* The grouped run is tight, iMessage-tight: 2px between a run's
         bubbles, 4px around a turn, no extra breathing inside the
         markdown — the bubble's own padding is the breathing. */
      --chat-bubble-assistant-gap: 2px;
      --chat-bubble-assistant-block-inset: 4px;
      --chat-markdown-inset: 0px;
      /* One metric: markdown prose steps down to the plain-text
         paragraph size (--p-size — what user bubbles render), and code
         chips, code blocks, and terminal rows all follow it relatively. */
      --chat-prose-size: var(--p-size);
      /* cap-to-font (this face's ratio is 0.72), then the same 0.9 step
         code chips take — terminal rows and inline code land on the
         identical pixel. */
      --chat-terminal-size: calc(var(--p-size) / 0.72 * 0.9);
      --chat-terminal-leading: 1.5;
      --chat-terminal-radius: 12px;
      /* The capture authors its prompt marker as SGR yellow and node
         refs as SGR cyan (the tsh role vocabulary). Terminal yellow on
         the received-gray ground reads as mustard — the marker stands
         down to iOS's secondary gray, and refs take the sent-blue. */
      --session-replay-ansi-yellow: #6e6e73;
      --session-replay-ansi-cyan: #0a84ff;
      /* Tool calls read as ADMIN MESSAGES — iMessage's system-line
         grammar: no ground of their own, lighter ink, smaller text.
         The Bash(…) label is the card's own condensed header. */
      --chat-toolcall-bg: transparent;
      --chat-toolcall-ink: #8e8e93;
      --chat-toolcall-size: calc(var(--p-size) / 0.72 * 0.8);
      --chat-toolcall-padding: 1px 0;
    }
  `,
};
